module.exports = __webpack_public_path__ + "static/desktop/img/paypal-curved-128px.4b5f30dc.png";